import { useState } from "react";
import Button from "../../utils/components/Button";
import Input from "../../utils/components/Input";
import Logo from "../../static/crane-login-logo.png";
import { useNavigate } from "react-router";
import toastr from "toastr";
import inputValidations from "../../utils/helpers/inputValidations";
import API from "../../utils/API";
import { useSearchParams } from "react-router-dom";
import { guest } from "../../App/routes";

const ResetPassword = ({ translate }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState({
    password: "",
    confirmPassword: "",
  });
  const [isSending, setIsSending] = useState(false);
  const [searchParams] = useSearchParams();

  const handleChange = (e) =>
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });

  const handleSubmit = (e) => {
    e.preventDefault();

    const { password, confirmPassword } = user;

    if (!inputValidations(password, "password")) {
      toastr.error(translate("auth.reset_password.invalid_password"));
      return;
    }

    if (password !== confirmPassword) {
      toastr.error(translate("auth.reset_password.password_not_match"));
      return;
    }

    setIsSending(true);

    const token = searchParams.get("token");

    API.resetPassword(token, { password, exit: false })
      .then(() => {
        toastr.success(translate("auth.reset_password.success"));
        navigate(guest.login.link);
      })
      .catch(() => setIsSending(false));
  };

  return (
    <div className="container-fluid d-flex flex-column align-items-center justify-content-center px-3 mt-5">
      <div className="row d-flex align-items-center justify-content-center mt-5">
        <div className="col-12 d-flex flex-column align-items-center mt-3">
          <img height={200} src={Logo} alt="logo" />
          <p className="text-center my-4 pt-2 fs-5">
            {translate("auth.reset_password.title")}
          </p>
        </div>
        <div className="col-12">
          <form action="post" onSubmit={handleSubmit}>
            <div className="mt-2">
              <Input
                type="password"
                name="password"
                className="d-block border-dark p-3"
                placeholder={translate("password")}
                required={true}
                value={user.password}
                onChange={handleChange}
                inputProps={{
                  readOnly: isSending,
                }}
              />
            </div>
            <div className="mt-2 mb-3">
              <Input
                type="password"
                name="confirmPassword"
                className="d-block border-dark p-3"
                placeholder={translate("confirm_password")}
                required={true}
                value={user.confirmPassword}
                onChange={handleChange}
                inputProps={{
                  readOnly: isSending,
                }}
              />
            </div>
            <Button
              type="submit"
              disabled={isSending}
              className="btn-orange w-100 mt-3 p-2 text-white fw-bold"
            >
              {translate("auth.reset_password.form_button")}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
